import { z } from 'zod';

export function getSingleValueWithOptionField(
  errorMessage: string,
  requiredMessage = 'questionnaire.option.required',
) {
  return z
    .object({
      value: z.string({ required_error: requiredMessage }).nonempty({ message: requiredMessage }),
      other: z.string().optional(),
    })
    .refine(({ value, other }) => value !== 'other' || other, {
      message: errorMessage,
      path: ['other'],
    })
    .transform(({ value, other }) => ({
      value,
      other: value === 'other' ? (other ?? null) : null,
    }));
}
